const en = {
    "language": "English",
    "/homePage": "Home",
    "/order": "Order",
    "/order/bookingSpace": "Booking Details",
    "/booking": "Booking",
    "/booking/bookingSpace": "Booking Details",
    "/billInfo": "Lading",
    "/billOfLading": "Bill Lading",
    "/billOfLading/ladingDetails": "B/L Details",
    "/billOfLading/ladingPreview": "B/L Preview",
    "/spliteBill": "Separate Bill",
    "/combineBill": "Combined Bill",
    "/spliteAndCombine": "Split&Combine Bill",
    "/track": "Track",
    "/cargoTrack": "Cargo Tracking",
    "/repairTrack": "Repair Quotation Tracking",
    "/freeTime": "Free Time",
    "/equipment": "Equipment",
    "/repair": "Repair",
    "/equipment/repair/estimate": "Repair Estimate",
    "/estimate/estimateDetails": "Estimate Details",
    "/equipment/repair/thirdPartyCharge": "Third Party Charge Management",
    "/equipment/demurrageRate": "Demurrage Rate",
    "/userCenter":"User Center",
    "/personalInfo":"Personal Information",
    "/reconciliation": "Reconciliation",
    "/confirmFreight": "Expense Information Search",
    "/billsManagement": "SOA Management",
    "/billsDetails": "SOA Details",
    "/invoiceApplication": "Invoice Management",
    "/invoiceDetails": "Invoice Details",
    "common": {
        "downloadButton": "Download",
        "searchButton": "Search",
        "resetButton": "Reset",
        "detail": "Detail",
        "viewDetails": "View Details",
        "newButton": "New",
        "preViewButton": "Preview",
        "editButton": "Edit",
        "detailsButton": "Details",
        "bookingButton": "Booking",
        "addButton": "Add",
        "addButton2": "Add",
        "appendButton": "Append",
        "copyNewButton": "Copy New",
        "deleteButton": "Delete",
        "cancelButton": "Cancel",
        "cancelButton2": "Cancel",
        "saveBtn": "Save",
        "skipBtn": "Skip",
        "selectInverse": "Invert Selection",
        "selectAll": "Select All",
        "operateColumn": "Operate",
        "menuColumn": "Menu",
        "exportTableData": "Export Data",
        "cardView": "Card",
        "tableView": "Table",
        "saveButton": "Save Draft",
        "saveAndSendButton": "Save and Send",
        "sendButton": "Send",
        "SODownloadButton": "S/O",
        "SOBatchDownloadButton": "S/O Batch Download",
        "BookingEdiImportBtnClick":"Booking Edi Import",
        "BookingEdiInstructBtnClick":"Booking Edi Instruct DownLoad",
        "PLDownloadButton": "Packing List(NSA)",
        "PLBatchDownloadButton": "Packing List Batch Download(NANSHA)",
        "blBatchDownload": "B/L Batch Download",
        "BatchDownloadPreviewFormatting":"Batch Preview",
        "blDownload": "B/L",
        "Preview":"Confirmation Preview",
        "guaranteeUpload": "Guarantee",
        "historyButton": "View History",
        "returnButton": "Return",
        "findButton": "Search",
        "closeButton": "Close",
        "confirmButton": "Confirm",
        "okButton": "OK",
        "okButton2": "OK",
        "ExcelDownloadButton": "Excel Import Template Download",
        "ExceluploadButton": "Excel Import",
        "tips": "Tips",
        "noData": "No Data",
        "noData2": "Sorry, there is no data at the moment!",
        "pleaseConfirm": "Please confirm",
        "pleaseSelect": "Please select",
        "pleaseEnter": "Please enter",
        "autoGenerate": "Automatically generated after booking confirmation",
        "multiBlNoEnter": "Please enter the B/L No., separated by commas (,) between multiple B/L Nos",
        "multiSoaNoEnter": "Please enter the SOA No., separated by commas (,) between multiple SOA Nos",
        "pleaseEnterContent": "Please enter the content",
        "pleaseEnterContent2": "Please enter the content. The maximum number of characters can be entered in a single line is 35",
        "pleaseSelectDate": "Please select date",
        "pleaseSelectSoDownloadTemplate": "Please select the S/O download template:",
        "yes": "Yes",
        "no": "No",
        "trackSearchButton": "Cargo Tracking Search",
        "total": "Total: ?",
        "tooLong": " is too long!",
        "blDownloadTooptip": "[?] has generated a B/L. Click \"Download\" to download the B/L generated before, and click \"Re download\" , the B/L PDF will be regenerated and downloaded based on the latest data. Please select",
        "selectFiles": "Select Files",
        "uploadFiles": "Upload Files",
        "guaranteeUploadTip": "Only *.pdf, *.png, *.jpg, *.jpeg can be uploaded, and up to 5 files can be uploaded. The size of a single file cannot exceed 5M",
        "uploadSIInfo": "SI Information Upload",
        "guaranteeUnSubmit": "Guarantee not submitted",
        "guaranteeSubmit": "Guarantee submitted",
        "guaranteeUnApproved": "Unapproved",
        "guaranteeApproving": "Under review",
        "guaranteeApproved": "Approved",
        "guaranteeRejected": "Failed to pass the review, please resubmit",
        "operation": "Operation",
        "viewButton": "View",
        "dragUploadTips1": "Drag files here, or ",
        "dragUploadTips2": "click to select files",
        "excelTemplateDL": "Import Template Download",
        "validateSucceed": "Verification succeeded!",
        "uploadConfirm": "Are you sure to upload now?",
        "uploadSucceed": "Upload succeeded!",
        "uploaded": "UPLOADED",
        "unuploaded": "UNUPLOADED",
        "committing": "Submitting, please wait...",
        "uploading": "Uploading, please wait...",
        "deleteFail": "Delete failed!",
        "deleteSuccess":"Delete succeeded!",
        "submitSuccess":"Submit succeeded!",
        "close":"Close",
        "menuHide": "Hide Menu",
        "menuShow": "Show Menu",
        "backAuto": "The current page will automatically close...",
        "noPermission": "No operation permissions currently available",
        "noFuncPermission": "Sorry, your account currently does not have access to this page. Please contact the related staff of Zhonggu to activate account permissions",
        "batch":"Batch Actions",
        "uploadVgm":"Upload VGM",
        "batchUploadVgm":"Batch Upload VGM",
        "confirm": "Confirm",
        "errorTip": "Some VGM data failed validation",
        "unknownError": "Unknown Error",
        "otherLanguageChars":"Special symbols or languages other than Chinese and English are not allowed",
        "enAndNumSupported":"Only English letters (A-Z) and numbers (0-9) are supported",
        "chineseChars":"Chinese characters are not allowed",
        "chinesePunctuation":"Chinese punctuation or Chinese spaces are not allowed",
        "overLength":"Input exceeds maximum length limit ({maxLength} characters)",
    },
    "billOfLading": {
        "siSubmitConfirm": "After officially submitting the SI, any subsequent modifications will incur amendment fees. If you are unsure, you can save as draft first and submit after confirmation. Are you sure you want to submit?",
        "iConfirmed": "I Confirmed",
    },
    "header": {
        "home": "Home",
        "order": "Order",
        "booking": "Booking",
        "lading": "Lading",
        "billLading": "Bill Lading",
        "track": "Track",
        "cargoTrack": "Cargo Tracking",
        "repairTrack": "Repair Quotation Tracking",
        "freeTime": "Free Time",
        "combineBill": "Combined Bill",
        "spliteBill": "Separate Bill",
        "spliteAndCombine": "Split&Combine Bill",
        "equipment": "Equipment",
        "repair": "Repair",
        "estimate": "Repair Estimate",
        "thirdPartyCharge": "Third Party Charge Management",
        "userCenter":"User Center",
        "personalInformation":"Personal Information",
        "reconciliation": "Reconciliation",
        "otherLink": "zhonggu Foreign Trade Platform",
        "platformName": "Zhonggu Foreign Trade",
        "logout": "Sign Out",
        "nonLogin": "Non-login",
        "confirmFreight": "Expense Information Search",
        "billManagement": "SOA Management",
        "invoiceManagement": "Invoice Management",
    },
    "homePage": {
        "login": "Sign in",
        "register": "Register now",
        "forgetPassword": "Forget password?",
        "welcome": "Welcome to login",
        "accountHolder":"Please enter the account number",
        "pwdHoder":"Please input a password"
    },
    "order": {
        "placeOrder": "Place Order",
        "pol": "POL",
        "pod": "POD",
        "polEtd": "POL ETD",
        "podEta": "POD ETA",
        "note1": "Usage Method",
        "note2": "It will display the results accroding to the conditions including POL、POD、ETD(A)、SERVICE TYPE",
        "note3": "Booking directly from query results",
        "note4": "Shipping Schedule Inquiry",
        "note5": "Please query shipping schedule according to POL、POD、ETD(A)、SERVICE TYPE",
        "note6": "ETD、ETA、SERVICE TYPE are not not-empty control",
        "note7": "Results",
        "note8": "Display vessel/voy in order of date",
        "note9": "Booking",
        "note10": "Click on [Booking] button, switch to booking interface, please click on [Save and Send] after inputting information",
        "note11": "The related staff will contact to you as soon as possible.",
        //船期表格
        "vesselName": "Vessel Name",
        "voyage": "Voyage No",
        "polTerminalCode": "Terminal",
        "polEta": "POL ETA",
        "polEtd2": "POL ETD",
        "podEta2": "POD ETA",
        "underway": "Used Hours",
        "serviceLineCode": "Service Line"
    },
    "bookingSpace": {
        "booking": {
            "bookingInfo": "Booking Information",
            "blInfo": "B/L Information",
            "bkNo": "Booking No.",
            "blNo": "B/L No.",
            "bookingStatus": "Booking Status",
            "blStatus": "B/L Status",
            "bookingType": "Shipping Mode",
            "transportationTerms": "Shipping Term",
            "paidType": "Freight Term",
            "agreementNo": "Pre Agmt No.",
            "sales": "Sales",
            "applicantUnit": "Applicant Unit"
        },
        "bl": {
            "blInfo": "B/L Information",
            "blType": "B/L OP Mode",
            "deliveryDocumentMethod": "Bill Type",
            "deliveryDocumentPlace": "Place of Issue",
            "deliveryDocumentQuantity": "Number of Issue",
            "paidPalce": "Paid Place",
            "releaseStatus": "Release Status",
            "blReleaseFlag": "Cargo Release Flag",
        },
        "shipperInfo": "Shipper Information",
        "shipper": "Shipper",
        "consigneeInfo": "Consignee Information",
        "consignee": "Consignee",
        "notify1Info": "Notify(1) Information",
        "notifier1": "Notify(1)",
        "notify2Info": "Notify(2) Information",
        "notifier2": "Notify(2)",
        "customer": {
            "address":"address",
            "city":"City Name",
            "provinceCode":"Province Code",
            "provinceName":"Province Name",
            "postCode":"Post Code",
            "countryCode": "Country Code",
            "tel": "Tel",
            "email": "Email",
            "enterpriseCode": "Enterprise Code",
            "note": "*If the above address,City Name,Province Code,Province Name,Post Code Country Code, Tel, Email and Enterprise Code are not checked, they will not be displayed on the B/L."
        },
        "place": {
            "placeInfo": "Place Information",
            "por": "POR",
            "portFrom": "POL",
            "portTo": "POD",
            "del": "DEL",
            "porName": "POR Name",
            "polName": "POL Name",
            "podName": "POD Name",
            "delName": "DEL Name",
            "portSelectionTipContent": "Please pay attention to service selection and filling specifications. According to your filling, the system will automatically determine the service type:\n• If POR ≠ POL: It will be regarded as entrusting our company to arrange foreign trade CCA feeder transportation, and confirm the corresponding freight.\n• If you need \"Domestic to Foreign\" service: Please fill in POR = POL, and actively contact our port customer service for arrangement.",
        },
        "main": {
            "vesselInfo": "Vessel Information",
            "vesselCode": "Vessel Code",
            "voyageNo": "Voyage No",
            "voyageLeg": "Voyage Leg",
            "saillingDate": "Sailling Date"
        },
        "branch": {
            "routingInfo": "Pre-carriage",
            "branchVesselCode": "Vessel Code",
            "branchVoyageNo": "Voyage No",
            "branchVoyageLeg": "Voyage Leg",
            "branchSaillingDate": "Sailling Date",
            "branchCarrier": "Carrier",
            "note": " *When the Pre-carriage is Zhonggu Domestic Trade Line, the feeder carrier should be 'ZGI'"
        },
        "cargo": {
            "cargoInfo": "Cargo Information",
            "quantity": "Quantity",
            "grossWeight": "Gross Weight(KG)",
            "netWeight": "Net Weight(KG)",
            "cargoSize": "Size(Cubic Meter)",
            "cargoDesc": "Cargo Desc",
            "shippingMark": "Shipping Mark",
            "packageType": "Package Type",
            "packageDesc": "Package Desc",
            "packageDescPlaceholder": "Please select package type",
            "hsCode": "HS CODE",
            "commodityCode": "Commodity Code",
            "commodityName": "Commodity Name",
            "packageTypeSearch": "Package Type Code",
            "packageDescSearch": "Package Type Desc",
            "hscodeTips" :"*If there are multiple HSCODEs, you need to fill them in. For example:123154,242344,123465",
        },
        "preContainer": {
            "preContainerInfo": "Pre Container Information",
            "containerType": "Size/Type",
            "quantity": "Qty",
            "cargoTypeCode": "Cargo Type Code"
        },
        "specialInfo": "Special",
        "bkImos": {
            "bkImo": "DG",
            "classType": "IMO Class",
            "unSeriseNo": "UN No.",
            "label": "Label",
            "packageDesc": "Packing Group",
            "packageCode": "Type of Packing",
            "property": "Shipping Name",
            "componentDesc": "Chemical Name",
            "emergencySeq": "EMS",
            "emergencyTelNo": "Emergency Contact",
            "quantity": "Quantity",
            "grossWeight": "Gross Weight",
            "netWeight": "Net Weight",
            "flashPoint": "Flash Point",
            "rateBase": "Flash Point Unit",
            "isPolutionFlag": "Marine Pollutant"
        },
        "bkReefers": {
            "bkReefer": "RF",
            "rateBase": "Unit",
            "temperature": "Temperature",
            "intakeNum": "Vent"
        },
        "bkSoc": "SOC",
        "bkAks": {
            "bkAk": "AK",
            "containerType": "SZTP",
            "akLength": "Length(cm)",
            "akWidth": "Width(cm)",
            "akHigth": "Height(cm)",
            "akGrossWeight": "Gross Weight(kg)"
        },
        "other": {
            "otherInfo": "Other Information",
            "remark": "Remark",
            "siRemark": "SI Remark",
            "rejectReason": "Reject Reason",
            "guaranteeSubmissionStatus": "Guarantee Submission Status",
            "guaranteeReviewStatus":"Guarantee Review Status",
            "reDownloadPrompt":"This bill of lading has been generated. Click \"Download\" to download the bill of lading generated previously. Click \"Re download\"  the bill of lading PDF will be re generated and downloaded according to the latest data. Please select",
            "download": "download",
            "reDownload": "Re download",
            "downloadFailed":"Download failed",
            "committed" : "COMMITTED",
            "uncommitted":"UNCOMMITTED",
            "pendingApproval":"PENDING APPROVAL",
            "approved":"APPROVED",
            "unApproved":"UNAPPROVED",
            "downloaFailed1":"The current bill has not been confirmed yet, so it is not supported to download the B/L",
            "downloaFailed2":"The Bill Type of the current bill is not Surrendered or SEA WAYBILL, so it is not supported to download the B/L temporarily",
            "downloaFailed3":"The current bill has not submitted the letter of guarantee or the guarantee of this B/L has not been approved, so it is not supported to download the B/L",
            "downloaFailed4": "The current bill has been cargo detained, so it is not supported to download the B/L",
            "downloaFailed5": "The current bill has not been released yet, so it is not supported to download the B/L",
            "downloaFailed6":"The bill of lading has been issued and does not support downloading the bill of lading",
            "tipsForUploadingFiles":"Have all the guarantee documents been added? Please upload at one time",
            "uploadFiles" : "Upload files",
            "laterUploadFiles":"Later upload files",
            "bldownload" : "Download Bill of Lading",
            "blReject":"blReject"
        },
        "container": {
            "containerInfo": "Container Information",
            "containerNo": "Container No",
            "containerType": "Size/Type",
            "sealNo1": "Seal No1",
            "sealNo2": "Seal No2",
            "sealNo3": "Seal No3",
            "sealNo4": "Seal No4",
            "quantity": "Quantity",
            "weight": "G.Weight(KGS)",
            "containerWeight": "TareWeight(KGS)",
            "cntrSize": "Size(CBM)",
            "cargoTypeCode": "Cargo Type",
            "containerManager": "CNTR Manager",
            "cargoDesc": "DESC. OF GOODS",
            "hsCode": "HS CODE",
            "classType": "IMDG CLASS",
            "unSerialNo": "UN NO.",
            "reeferTemp": "Temperature",
            "operation": "Operation",
            "validateFileTypeFailed": "Upload failed! Only Excel files in .xls and .xlsx format can be uploaded"
        }
    },
    /*订舱查询页*/
    "booking": {
        "bookingSearch": "Booking Search",
        "spliteSearch": "Separate Bill Search",
        "combineSearch": "Combine Bill Search",
        "blSearch": "B/L Search",
        "vesselCode": "Vessel Code",
        "vvl": "Vessel/Voyage",
        "vesselName": "Vessel Name",
        "voyage": "Voyage",
        "loadingPort": "POL",
        "dischargePort": "POD",
        "sailingTimeStart": "Sailling Date From",
        "sailingTimeEnd": "Sailling Date To",
        "crateTimeStart": "CrateTime From",
        "crateTimeEnd": "CrateTime To",
        "bkNo": "Booking No.",
        "blNo": "B/L No.",
        "bookingStatus": "Booking Status",
        "blStatus": "B/L Status",
        "popover": {
            "no": "No.",
            "vessel": "Vessel Code",
            "vesselCode": "Vessel Code",
            "vesselNameCn": "Vessel Name",
            "vesselNameCN": "Vessel Name Cn",
            "voyageNo": "Voyage No",
            "voyageLeg": "Voyage Leg"
        },
        /*舱单表格*/
        "no": "No.",
        "pol": "POL",
        "polEtd": "ETD",
        "pod": "POD",
        "podEta": "ETA",
        "del": "DEL",
        "rejectReason": "Reject Reason",
        "updatedDtmLoc": "Last Updated Time",
        "remark": "Remark",
        "guaranteeUpload": "Guarantee Uploading",
        "guaranteeSubmissionStatus": "Guarantee Submission",
        "guaranteeReviewStatus": "Guarantee Review",
        "guaranteeReviewedRemarks": "Review Remarks",
        "enclosurName": "File Name",
        "uploadTime": "Upload Time",
        "containerInfoType": "Container Info Type",
        "blTemplate": "Select Template",
        "blTemplateDL":"Download Template",
        "cargoDescOGSShow": "Cargo Description",
        "cntrOgsShow": "Show the QGS of Splitting Containers",
        "EDIMessageImport":"EDI Message Import",
        "bookingInstruct":'[Note] Booking EDI message upload only supports notepad files in *.txt,*.edi format; Please click on the "Download EDI Message Instructions for Booking" button to download the document structure description',
        "EDIMessageUpload":"EDI Message Upload",
        "importResult":"Import Result",
        "billInstruct":'[Note] The bill of lading EDI message upload only supports notepad files in *.txt,*.edi format; Please click on the "Bill of Lading EDI Message Description Download" button to download the document structure description“',
        "billEDIMessageImport":"B/L EDI Import",
        "billEDIMessageInstructDownLoad":"B/L EDI Instructions",
        "sumitSiInformation":"Batch submission of SI",
        "copyNewDialogTitle": " Confirmation of Shipping Schedule",
        "cancelCopyButton": "Cancel Copy",
        "confirmCopyButton": "Confirm Copy",
        "copyNewTips1" :"* If you want to add a copy of booking information for the same voyage, you can click \"Confirm Copy\" directly.",
        "copyNewTips2" :"* If adding a copy of booking information for different voyages, please select the shipping schedule information for this booking first, and then click confirm.",
        "containerTypeAndQuantity" :"Container Type & Quantity",
    },
    /*提单预览/下载组件*/
    "blFormatSettings": {
        "previewMdoe": "Preview",
        "downloadMode": "Dpwnload",
        "headerTitle": "B/L-{previewBlNo} {mode} Format Options",
        "headerSubTitle-preview": "Choose the B/L preview format and the type of container information to be displayed.(Supports real-time preview)",
        "headerSubTitle-download": "Choose the type and format of container information to be displayed on the B/L",
        "currentSelected": "Selected",
        "choosePreviewTemplate": "Choose the B/L Preview Format",
        "blConfimationTemplate": "(Trunk)BL DRAFT",
        "feederBlConfimationTemplate": "(Feeder)BL DRAFT",
        "lastBlConfimationTemplate": "(Last Main Route) B/L Confirmation",
        "chooseContainerFormat": "Choose the Type of Container Information",
        "containerNo": "CTN NO.",
        "sealNo": "Seal NO.",
        "size": "CTN Size",
        "quantity": "PCS",
        "grossWeight": "G.W",
        "volume": "VOL",
        "cargoDesc": "DESC. OF GOODS",
        "hsCode": "HS CODE",
        "tareWeight": "T.W",
        "containerType": "CTN Type",
        "ctnNo-sealNo-size": "CTN NO./Seal NO./CTN Size",
        "ctnNo-sealNo-size-jmt": "CTN NO./CTN Type/Seal NO./PCS&G.W&VOL",
        "ctnNo-sealNo-size-jmt-hm-hscode": "CTN NO./CTN Type/Seal NO./PCS&G.W&VOL/DESC. OF GOODS/HS CODE",
        "ctnNo-sealNo-size-vol": "CTN NO./Seal NO./CTN Type/PCS&G.W&T.W&VOL",
        "simpleContainerInfoTips": "The 'Container and Seal No.' section in the B/L only displays the container No., seal No. and container size information, which is applicable to situations where only basic container information needs to be printed",
        "completeContainerInfoTips": "The 'Container and Seal No.' section of the B/L will display complete container information, including container No., seal No., container size, number of pieces, gross weight, and volume information",
        "completeContainerInfoTips2": "The 'Container and Seal No.' section of the B/L will display complete container information, including container No., seal No., container type, number of pieces, gross weight, tare weight, and volume information",
        "specialContainerInfoTips": "The 'Container and Seal No.' section of the B/L will display complete container information, including container No., seal No., container type, number of pieces, gross weight, tare weight, volume, desc. of goods and hs Code information",
        "previewRefreshTips": "Preview will be displayed here after clicking the Preview button",
        "previewBtn": "Preview",
        "closeBtn": "Close",
        "cancelBtn": "Cancel",
        "downloadBtn": "Download",
        "cargoDescOptions": "Description of Goods Content Settings (Optional)",
        "cntrOgsShow": "Show the QGS of Splitting Containers",
        "loadingTips": "Loading report, please wait...",
        "previewFailedTips": "Failed to generate preview",
        "blConfimationTemplateTips": "Default B/L preview format for most scenarios",
        "feederBlConfimationTemplateTips": "For scenarios where only the information of the main vessel needs to be displayed on the transit B/L",
        "lastBlConfimationTemplateTips": "For scenarios where both feeder and main ship information need to be displayed on the transit B/L simultaneously",
    },
    /*货物跟踪*/
    "cargoTrack": {
        "title": "zhonggu Cargo Tracking Query",
        "billInfo": "B/L Information",
        "blNo": "B/L No.",
        "por": "POR",
        "pol": "POL",
        "pod": "POD",
        "del": "DEL",
        "voyageInfo": "Voyage Information",
        "vesselName": "Vessel Name",
        "voyage": "VoyageNo",
        "portFromName": "Port From",
        "departureTime": "Departure Time",
        "portToName": "Port To",
        "arrivalTime": "Arrival Time",
        "containerInfo": "Latest Container Movement",
        "containerNo": "Container No.",
        "containerType": "Container Type",
        "latestDynamicDesc": "Latest Movement",
        "note": "All cargo tracking information is for reference only"
    },
    /*修箱报价查询*/
    "repairTrack": {
        "repairSearchButton": "Repair Tracking Search",
        "title": "zhonggu Repair Tracking Query",
        "repairInfo": "Repair Information",
        "receiveAndRefund": "Receive&Refund Information",
        "estimateNo": "Estimate No.",
        "blNo": "B/L No.",
        "containerNo": "Container No.",
        "repairCompany": "Repair Company",
        "repairPlace": "Repair Place",
        "applyDate": "Apply Date",
        "actualAmount": "Final Amount",
        "currency": "Currency",
        "factFinalDate": "Final Date",
    },
    /*拆单*/
    "spliteBill": {
        "no": "No.",
        "voyageSpliteSearch": "Split Search",
        "cancelSpliteButton": "Cancel Split",
        "queryHBLByVoyageButton": "Sub B/L Query",
        "newHBLButton": "Sub B/L New",
        "saveHBLButton": "Sub B/L Save",
        "deleteHBLButton": "Sub B/L Delete",
        "copyToHBLButton": "Copy to Sub B/L",
        "VVL": "Vessel/Voyage",
        "vesselCode": "Vessel Code",
        "vesselName": "Vessel Name",
        "voyageNo": "Voyage No.",
        "bkNo": "Booking No.",
        "blNo": "B/L No.",
        "billInfo": "Bill Information",
        "spliteCombinDesc": "Split or Combin",
        "voyageLeg": "Voyage Leg",
        "pol": "POL",
        "pod": "POD",
        "fwdDes": "Fwd Des",
        "consigneeName": "Consignee Name",
        "shipperName": "Shipper Name",
        "notify1Name": "Notify1 Name",
        "masterPreContainerInfo": "Top B/L Pre Container Information",
        "containerType": "Container Type",
        "quantity": "Quantity",
        "cargoTypeCode": "Cargo Type",
        "hblInfo": "Sub B/L Information",
        "cargoCommodityCode": "Commodity Code",
        "cargoCommodityName": "Cargo Commodity Name",
        "cargoShippingMark": "Cargo Shipping Mark",
        "cargoQuantity": "B/L Quantity",
        "cargoGrossWeight": "B/L Gross Weight",
        "cargoNetweight": "B/L Net Weight",
        "cargoSize": "B/L Cargo Size",
        "hBLPreContainerInfo": "Sub B/L Pre Container Information",
        "containerTypeAndQuantity": "Container Type & Quantity",
        "hBLSearch": "Sub B/L Query",
    },
    /*并单*/
    "combineBill": {
        "no": "No.",
        "voyageCombineSearch": "Combin Search",
        "cancelCombineButton": "Cancel Combin",
        "setBlNoForMBLButton": "Set As Top B/L",
        "queryHBLByVoyageButton": "Sub B/L Query",
        "removeHBLButton": "Sub B/L Remove",
        "VVL": "Vessel/Voyage",
        "vesselCode": "Vessel Code",
        "vesselName": "Vessel Name",
        "voyageNo": "Voyage No.",
        "bkNo": "Booking No.",
        "blNo": "B/L No.",
        "pol": "POL",
        "pod": "POD",
        "del": "DEL",
        "billInfo": "Bill Information",
        "consigneeName": "Consignee Name",
        "shipperName": "Shipper Name",
        "notify1Name": "Notify1 Name",
        "cargoCommodityName": "Cargo Commodity Name",
        "cargoShippingMark": "Cargo Shipping Mark",
        "cargoQuantity": "B/L Cargo Quantity",
        "cargoGrossWeight": "B/L Gross Weight",
        "cargoSize": "B/L Cargo Size",
        "transportationTerms": "Shipping Terms",
        "masterPreContainerInfo": "Top B/L Pre Container Information",
        "containerType": "Container Type",
        "quantity": "Quantity",
        "cargoTypeCode": "Cargo Type",
        "hblInfo": "Sub B/L Information",
        "hBLPreContainerInfo": "Sub B/L Pre Container Information",
        "containerTypeAndQuantity": "Container Type & Quantity",
    },
    /*估价单*/
    "estimate": {
        "estimateSearch": "Estimate Inquiry",
        "estimateNo": "Estimate No.",
        "containerNo": "Container No.",
        "applyDateStart": "Apply Date From",
        "applyDateEnd": "Apply Date To",
        "factFinalDateStart": "Fact Final Date From",
        "factFinalDateEnd": "Fact Final To",
        "repairStatus": "Repair Status",
        "estimateExcelImport": "Estimate Import",
        "estimateExcelImportNew": "Estimate Import(New)",
        "estimatePicturesBatchImport": "Damage Pics Import",
        "completedPicturesBatchImport": "Complete Pics Import",
        "senderCode": "Sender Code",
        "portAndDepot": "Port/Depot",
        "vvl": "Vessel/Voyage",
        "vesselCode": "Vessel",
        "voyageNo": "Voyage",
        "containerType": "Container Type",
        "blNo": "B/L No.",
        "portCode": "Port Code",
        "depotCode": "Deprt Code",
        "applyDate": "Apply Date",
        "picStatus": "Damage-pics Upload",
        "completePicStatus": "Complete-pics Upload",
        "receive": "Receive",
        "refund": "Refund",
        "factFinalDate": "Fact Final Date",
        "remark": "Remark",
        "approveDate": "Approve Date",
        "approver": "Approver",
        "versionStatus": "Version Status",
        "updatedDtmLoc": "Last Updated Time",
        "paymentBillFlag": "Payment Bill Flag",
        "estimateAccount": "Apply Total Account",
        "approveAccount": "Final Price",
        "currency": "Currency",
        "thirdCustomerChargeImport": "Third Party Charge Import",
        "estimateUpload": "Repair Estimate Upload",
        "estimateUploadNew": "Repair Estimate Upload(New)",
        "uploadTips": "(Some browsers may not support drag file to upload, please use Google)",
        "uploadTips1": "【Note】 Only EXCEL files in *.xls,*.xlsx format are supported for uploading; The upload of the repair pictures supports the picture in the .jpg,.jpeg,.png,.bmp,.gif formats. Please click the \"File Upload Description\" at the bottom for the structure and naming requirements of the compressed files",
        "picUploadTips": "Instructions for uploading repair pictures",
        "picUploadTips1": "File Upload Description",
        "estUpload": "Estimate Upload",
        "picUpload": "Pictures Upload",
        "picBatchUpload": "Batch import of damage pictures",
        "completePicBatchUpload": "Batch import of complete pictures",
        "picBatchUploadTips": "【Note】 The upload of the repair pictures supports the picture in the .jpg,.jpeg,.png,.bmp,.gif formats. Please click the \"File Upload Description\" at the bottom for the structure and naming requirements of the compressed files",
        "picBatchUploadTips1": "Instructions for batch upload of repair pictures",
        "uploadFiles": "Upload Files",
        "uploadCompleted": "Import Complete",
        "pleaseSelectFiles2Upload": "Please select a file to upload!",
        "wrongEstimateFormat": "Upload file format error! Only EXCEL files in .xls or .xlsx format are supported for uploading",
        "wrongPicFormat": "Upload file format error! The upload of the repair pictures only supports the compressed files in the .zip format",
        "uploading": "Importing, please wait...",
        "excelTemplateDL": "Estimate Import Template Download",
        "excelTemplateDLNew": "(New)Estimate Import Template Download",
        "uploadSizeLimit": "The size of file [{fileName}] exceeds the maximum limit(fileSize). The size of a single file cannot exceed 20M!",
        "finishValidate": "Estimate(Container No.[{containerNo}],{fieldName} can not be empty!",
        "finishComfirm": "The approval freight of the estimate after finish will be used for financial account, please confirm whether it is finished?",
        "failed2finish": "Estimate No.[{estimateNo}] is not in the approved status, can not be finished. Please re select;",
        "failed2finish2": "Container No.[{containerNo}] has no repair-completed pictures, can not be finished. Please re select;",
        "repairFinishButton": "Repair Finish",
        "batchFinish": "Repair Finish",
        "batchFinishNote": "【Note】 The act final date and remarks column can be set separately in the table (double click the specified cell to editing), or enter the date and remarks at the bottom, which will be applicable to all records in the table above;",
    },
    "estimateDetails": {
        "estimatePicturesBatchUpload": "Damage Pics Upload",
        "completedPicturesBatchUpload": "Complete Pics Upload",
        "index": "No.",
        "estimateDetails": "Estimate Details Information",
        "senderCode": "Sender Code",
        "portCodeAnddepotCode": "Port/Depot",
        "officeCode": "Office",
        "applyDate": "Apply Date",
        "estimateNo": "Estimate No.",
        "containerNoAndcontainerType": "Container No./Type",
        "containerNo": "Container No.",
        "containerType": "Container Type",
        "repairType": "Repair Type",
        "preFinalDate": "Pre Final Date",
        "movement": "E/F Status",
        "vesselCodeAndvoyageNo": "Vessel/Voyage",
        "blNo": "B/L No.",
        "recvFlag": "Recv Flag",
        "currency": "Currency",
        "discount": "Discount",
        "repairStatus": "Repair Status",
        "manufacture": "Manufacture",
        "onhiredDate": "On Hired Date",
        "party": "Repairer",
        "updatedByUser": "Last Updated By User",
        "updatedDtmLoc": "Last Updated Time",
        "maker": "Maker",
        "modelNo": "Model",
        "warrantyPeriod": "warranty Period",
        "estBodyMachines": {
            "estBodyInfo": "Body Information",
            "estBodyMachineInfo": "Machine Information",
            "componentCode": "Component",
            "repairLocationCode": "Repair Location",
            "damageCode": "Damage",
            "repairCode": "Repair",
            "materialCode": "Material",
            "partNo": "Part No.",
            "length": "Length",
            "width": "Width",
            "quantity": "Quantity",
            "loborRate": "Lobor Rate",
            "workHours": "Work Hours",
            "laborCost": "Labor Cost",
            "materialRate": "Material Rate",
            "materialCost": "Material Cost",
            "estimateAccount": "Apply Account",
            "approveAccount": "Approve Account",
            "receiveAccount": "Receive Account",
        },
        "labTotal": "Lab Total",
        "matTotal": "Mat Total",
        "applyTotal": "Apply Total Account",
        "approveTotal": "Appr Total",
        "applyRemark": "Apply Remark",
        "approveRemark": "Approve Remark",
        "receiveRemark": "Receive Remark",
        "estContainerPic": {
            "estContainerPicInfo": "Damage Container Picture Information",
            "estCompleteContainerPicInfo": "Complete Container Picture Information",
            "index": "No.",
            "fileName": "File Name",
            "isRepairCompleted": "Picture Type",
            "createdDtmLoc": "Upload Date",
            "remark": "Remark",
            "picPreview": "Picture Preview",
            "tips": " No Picture Information Obtained",
            "damage": "Dmage",
            "complete": "Complete",
            "wrongPicFormat": "Format error of uploaded picture! Only *.jpg, *.jpeg, *.png, *.bmp, *.gif files can be uploaded",
            "uploadSizeLimit": "The size of file [{fileName}] exceeds the maximum limit(fileSize). The size of a single file cannot exceed 5M!",
            "deletePicConfirm": "Are you sure to delete the picture {fileName}? After confirming and clicking the Save button at the bottom, the deletion cannot be canceled",
            "deleteConfirm": "Are you sure to delete these pictures? After confirming and clicking the Save button at the bottom, the deletion cannot be canceled",
        },
        "estimateCustomerCharge": {
            "estimateCustomerChargeInfo": "Third Party Charge Information",
            "index": "No.",
            "receiveDate": "Receive Date",
            "receiveAmount": "Receive Amount",
            "currency": "Currency",
            "approverAmount": "Approver Amount",
            "approverDate": "Approve Date",
            "approver": "Approver",
            "refundDate": "Refund Date",
            "refundAmount": "Refund Amount",
            "remark": "Remark",
        },
        "estimateDeleteConfirm": "To delete current estimate, the deduction record will be deleted in cascade. Are you sure you want to delete it?",
        "saveEstimateFirst": "Please save the current estimate information first!",
    },
    /*第三方收退费*/
    "thirdPartyCharge": {
        "thirdPartyChargeSearch": "Third Party Charges Search",
        "index": "No.",
        "estimateNo": "Estimate No.",
        "containerNo": "Container No.",
        "depotCode": "Depot Code",
        "createdDtmLoc": "CrateTime",
        "crateTimeStart": "CrateTime From",
        "crateTimeEnd": "CrateTime To",
        "customerChargeExcelImport": "Third Party Charges Import",
        "customerChargeUpload": "Third Party Charges Upload",
        "senderCode": "Sender Code",
        "receiveDate": "Receive Date",
        "receiveAmount": "Receive Amount",
        "currency": "Currency",
        "refundDate": "Refund Date",
        "refundAmount": "Refund Amount",
        "remark": "Remark",
        "actualAmount": "Actual Amount",
        "uploadTips": "【Note】 Only EXCEL files in .xls or .xlsx format are supported for uploading;",
        "validateInfo": "Verification Result",
        "validating": "Importing, business verification in progress...",
    },
    /*费用信息查询*/
    "confirmFreight": {
        "title": "Expense Information Search",
        "no": "No.",
        "vvl": "Vessel/Voyage",
        "vesselCode": "Vessel Code",
        "vesselName": "Vessel",
        "voyageNo": "Voyage No.",
        "voyageLeg": "Voyage Leg",
        "year": "Year",
        "settleMonth": "Month",
        "saillingDate": "Sailling Date",
        "sailingTimeStart": "Sailling Date From",
        "sailingTimeEnd": "Sailling Date To",
        "blNo": "B/L No.",
        "charge": "Charge",
        "chargeCode": "Charge Code",
        "chargeName": "Charge Name",
        "chargeNameCn": "charge Name Cn",
        "currency": "Currency",
        "isReconciliated": "Reconciliation Flag",
        "voyageInfo": "Voyage Information",
        "amountTotal": "Amount Total",
        "freightInfo": "Rate Details",
        "caculateQty": "Caculate Qty",
        "caculateUnit": "Caculate Unit",
        "amount": "Amount",
        "payer": "Payer",
        "customerName": "Payer Name",
        "customerNameCn": "Payer Name(CN)",
        "payModel": "Pay Model",
        "today": "Today",
        "yesterday": "Yesterday",
        "beforeOneWeek": "before One Week",
        "button": {
            "billGenerateBtn": "Generate Bills",
            "exportTableDataBtn": "Export Data"
        },
        "message": {
            "searchValidate": "The Vessel/Voyage and Year/Month conditions cannot both be empty! Please enter at least one to query",
            "billGenerateValidate": "Please select expense details！",
            "freightStatusValidate": "Check the box to include reconciled expenses. Please reselect！",
        },
        "costInformationQuery": "Expense Information Search",
        "isReconcile": "Reconcile Or Not",
    },
    invoiceApplication: {
        "title": "Invoice Message Query",
        "invoiceNo": "Invoice No",
        "invoiceHeader": "Invoice Header",
        "issuedDateFrom": "Issued Date From",
        "issuedDateTo": "Issued Date To",
        "currency": "Invoice Currency",
        "totalAmount": "total Amount",
        "isCancelled": "Invoice Status",
        "invoiceType": "Invoice Type",
        "BusinessNo": "Business No",
        "ledgerCompNo": "Ledger CompNo",
        "hasNoExpressNumber": "Has No Express Number",
        "delete": "delete",
        "submit": "submit",
        "issuedDate": "Issued Date",
        "trackingNumber": "Tracking Number",
        "payerName": "Payer Name",
        "quoteCurrency": "Original Currency",
        "quoteAmount": "Original Amount",
        "isInvoice": "Is Invoice",
        "relationInvoiceNo": "Relation InvoiceNo",
        "relationIssuedDate": "Relation Issued Date",
        "feeDetail": "Fee Detail",
        "card": "Card",
        "table": "Table",
        "remark": "Remark",
        "invoiceDownload": "Invoice Download",
        "exportData": "Export Data",
        "operation": "Operation",
    },
    "invoiceDetails": {
        "invoiceBaseInfo": "Invoice Base Info",
        "invoiceNo": "Invoice No",
        "accountNo": "Account No",
        "bankName": "Bank Name",
        "invSettleOffice": "InvSettle Office",
        "invoiceHeader": "Invoice Header",
        "vesselCodeVoyage": "Vessel Code And Voyage",
        "businessNo": "Bl No",
        "blNo": "Bl No",
        "issuedDate": "Issued Date",
        "etd": "ETD",
        "eta": "ETA",
        "electronicInvoiceFlag": "Electronic Invoice Flag",
        "invoiceType": "Invoice Type",
        "portLoadName": "Port Load Name",
        "portDiscName": "Port Disc Name",
        "portDestName": "Port Dest Name",
        "taxVersionNum": "Tax Version Num",
        "quoteCurrency": "Original Currency",
        "quoteAmount": "Original Amount",
        "payerBank": "Payer Bank",
        "payerAccountNo": "Payer Account No",
        "payerContacts": "Payer Contacts",
        "payerTel": "Payer Tel",
        "customerEmail": "Customer Email",
        "payerBillingAddress": "Payer Billing Address",
        "businessRegisterNo": "Business Register No",
        "taxRegisterNo": "Tax Register No",
        "quantity": "Quantity",
        "unitPrice": "Unit Price",
        "currencyType": "Currency",
        "settleAmount": "Settle Amount",
        "remark": "Remark",
        "totalAmountB": "Total Amount B",
        "totalAmountS": "Total Amount S",
        "rateMonth": "Rate Month",
        "exchangeRate": "Exchange Rate",
        "invoiceBLInfo": "Invoice BL Info",
        "ledgerCompNo": "Ledger Comp No",
        "vesselCode": "Vessel Code",
        "voyageNo": "Voyage No",
        "voyageLeg": "Voyage Leg",
        "primeCurrencyCode": "Prime Currency Code",
        "primeCurrencyValue": "Prime Currency Value",
        "ledgerPartnerName": "Ledger Partner Name",
        "officeId": "Office Id",
        "invoiceStatus": "Invoice Status",
        "allocatedStatus": "Allocated Status",
        "expenseDetails": "Expense Details",
        "expenseCode": "Charge Code",
        "expenseName": "Charge Name",
        "invoiceAmount": "Invoice Amount",
        "rateToInvoice": "Rate To Invoice",
        "invoicablePrimeCurrencyValue": "Invoicable Original Currency Amount",
        "invoicedPrimeCurrencyValue": "Invoiced Original Currency Amount",
        "businessSeal": "Business Seal",
        "receiver": "Receiver",
        "applicatEmail": "Applicat Email",
        "finDeliveryAddress": "Fin Delivery Address",
        "checkedName": "Checked Name",
        "submit": "Submit",
        "returnApply": "Return Apply",
        "chargingContent": "Charging Content",
        "customerName": "Customer Name",
        "carriedForward":"The SOA is being carried forward to finance...",
        "invoiceSave":"Saving invoice, please wait...",

    },
    /*对账单信息查询*/
    "billsManagement": {
        "title": "SOA Information Query",
        "vvl": "Vessel/Voyage",
        "soaNo": "SOA No.",
        "blNo": "B/L No.",
        "confirmStatus": "Confirm Flag",
        "confirmDateStart": "Confirm Date From",
        "confirmDateEnd": "Confirm Date To",
        "createTimeStart": "Create Time From",
        "createTimeEnd": "Create Time To",
        "invoiceStatus": "Invoice Flag",
        "balanceUnitsEn": "Payer Name",
        "balanceUnitsCn": "Payer Name(CN)",
        "currency": "Currency",
        "amount": "Amount",
        "createdByUser": "Created By User",
        "createdDtmLoc": "Created Date",
        "confirmByUser": "Confirm By User",
        "confirmDate": "Confirm Date",
        "remark": "Remark",
        "button": {
            "confirmBtn": "Confirm",
            "cancelConfirmBtn": "Cancel Confirm",
            "invoiceBtn": "Invoicing",
            "billsDownload": "SOA Download",
            "pdfDownload": "PDF Download",
            "excelDownload": "Excel Download",
        },
        "message": {
            "noDetails":"Please select the expense details to delete!",
            "removeExpense":"Are you sure to remove the selected expense from the SOA expense details?",
            "cannotConfirmAgain":"The SOA is in confirmation status and doesn't require further confirmation!",
            "confirmSuccess":"Confirm success!",
            "cannotCancelConfirm":"The SOA is in unconfirmed status, unable to cancel confirmation！",
            "cannotInvoice":"The SOA is not in confirmed status and cannot be invoiced. Please confirm first！",
            "invoice":"Are you sure to invoice?",
            "generatingInvoice":"Generating invoice content, please wait...",
            "cannotDeleted":"The SOA is not in unconfirmed status and cannot be deleted!",
            "deleteFailed":"Delete failed",
            "deleteSOA":"Are you sure to delete the SOA?",
            "leastOne":"The ship name/voyage and year/month conditions cannot both be empty! Please enter at least one item to query",
            "notSelected":"Expense details not selected！",
            "saveFailed":"Save failed",
            "savedSuccessfully":"Saved successfully",
        }
    },
    /*对账单基本信息*/
    "billsDetails": {
        "title": "SOA Essential Information",
        "index": "No.",
        "soaNo": "SOA No.",
        "balanceUnits": "Balance Units Code",
        "balanceUnitsEn": "Player Name",
        "balanceUnitsCn": "Player Name(CN)",
        "createdByUser": "createdByUser",
        "createdDtmLoc": "createdDtmLoc",
        "confirmFlag": "Confirm Flag",
        "invoiceFlag": "Invoice Flag",
        "remark": "Remark",
        "tableCurrencyAmountInfo": {
            "title": "Amount Receivable",
            "note": "(Total By Currency)",
            "currency": "Currency",
            "amount": "Amount"
        },
        "tableVoyageInfo": {
            "title": "Voyage Information",
            "vesselCode": "Vessel Code",
            "vesselName": "Vessel Name",
            "voyageNo": "Voyage No.",
            "voyageLeg": "Voyage Leg",
        },
        "tableFreightReceivableInfo": {
            "title": "Rate Details",
            "index": "No.",
            "saillingDate": "Sailling Date",
            "vesselCode": "Vessel Code",
            "vesselName": "Vessel Name",
            "voyageNo": "Voyage No.",
            "voyageLeg": "Voyage Leg",
            "blNo": "B/L No.",
            "chargeCode": "Charge Code",
            "chargeName": "Charge Name",
            "currency": "Currency",
            "amount": "Amount",
            "payerNameCn": "Payer Name(CN)",
            "payerName": "Payer Name",
            "caculateQty": "Caculate Qty",
            "containerType": "Container Type",
            "caculateUnit": "Caculate Unit",
            "payModel": "Pay Model",
            "cargoTypeCode": "Cargo Type Code",
            "agreementNo": "Agreement No",
        },
        "tableBLNoInfo": {
            "index": "No.",
            "blNo": "B/L No.",
        },
        "freightAddDialog": {
            "title": "Add Charges",
            "vesselCode": "Vessel Code",
            "vesselName": "Vessel Name",
            "voyageNo": "Voyage No",
            "voyageLeg": "Voyage Leg",
            "blNo": "B/L No.",
            "sailingTimeStart": "Sailling Date From",
            "sailingTimeEnd": "Sailling Date To",
            "year": "year",
            "month": "month",
            "currency": "currency",
            "chargeCode": "Charge Code",
        },
        "button": {
            "addCostBtn": "Add Charges",
            "removeCostBtn": "Remove Charges",
            "ConfirmBtn": "Confirm",
            "cancelConfirmBtn": "Cancel Confirm",
            "invoiceBtn": "Invoicing",
            "billsDownload": "SOA Download",
            "billsDownloadPdfBtn": "PDF Download",
            "billsDownloadExcelBtn": "Excel Download",
            "searchBtn": "Search"
        },
        "pdfDownLoad":"PDF download success!",
        "excelDownLoad":"EXCEL download success!",
        "produceBill":"Successfully saved! Generate statement:",
        "copyBillNo":"Copy SOA No.",
    },
    /*信息*/
    "message": {
        "loginFirst": "Please login first",
        "failMsg": "Operation failed!",
        "account": "Please enter the account number",
        "passWord": "Please input a password",
        "logoutMsg": "Currently logged out!",
        "loadingPortValidate": "Please select port of loading",
        "dischargePortValidate": "Please select port of discharge",
        "pleaseSelect2preView": "Please select which record you want to preview",
        "pleaseSelect2operate": "Please select which record you want to operate",
        "pleaseSelect2Edit": "Please select which record you want to edit",
        "pleaseSelect2Send": "Please select which record you want to send",
        "pleaseSelect2Copy": "Please select which record you want to copy",
        "pleaseSaveFirst": "The current page Booking Information has not been saved, please save it first",
        "preContainerDeleteConfirm": "Are you sure to delete the currently selected Pre Container record?",
        "imoDeleteConfirm": "Are you sure you want to delete the last IMO DG record?",
        "reeferDeleteConfirm": "Are you sure you want to delete the last Reefer record?",
        "akDeleteConfirm": "Are you sure you want to delete the last AK record?",
        "containerDeleteConfirm": "Are you sure you want to delete the Container with container No.:",
        "bkNoNotNull": "Booking No. cannot be empty!",
        "blNoNotNull": "B/L No. cannot be empty!",
        "agreementNoNotNull": "Pre Agmt No. cannot be empty!",
        "porNotNull": "POR cannot be empty!",
        "delNotNull": "DEL cannot be empty!",
        "transportationTermsNotNull": "Shipping Term cannot be empty!",
        "paidTypeNotNull": "Freight Term cannot be empty!",
        "applicationUnitNotNull": "Applicant Unit cannot be empty!",
        "deliveryDocumentMethodNotNull": "Bill Type cannot be empty!",
        "hsCodeNotNull": "HS CODE cannot be empty!",
        "deliveryDocumentPlaceNotNull": "Place of Issue cannot be empty!",
        "porNameNotNull": "POR Name cannot be empty!",
        "polNameNotNull": "POL Name cannot be empty!",
        "podNameNotNull": "POD Name cannot be empty!",
        "delNameNotNull": "DEL Name cannot be empty!",
        "classTypeNotNull": "【DG Information】Line {index}: IMO Class cannot be empty!",
        "unSeriseNoNotNull": "【DG Information】Line {index}: UN No. cannot be empty!",
        "packageDescNotNull": "【DG Information】Line {index}: Packing Group cannot be empty!",
        "packageCodeNotNull": "【DG Information】Line {index}: Type of Packing cannot be empty!",
        "propertyNotNull": "【DG Information】Line {index}: Shipping Name cannot be empty!",
        "componentDescNotNull": "【DG Information】Line {index}: chemical Name cannot be empty!",
        "emergencySeqNotNull": "【DG Information】Line {index}: Emergency Contact cannot be empty!",
        "rateBaseNotNull": "【RF Information】Line {index}: Unit cannot be empty!",
        "temperatureNotNull": "【RF Information】Line {index}: Temperature cannot be empty!",
        "intakeNumNotNull": "【RF Information】Line {index}: Vent cannot be empty!",
        "noBkContainer": "Unable to send, please enter the Container Information!",
        "searching": "Searching...",
        "saving": "Saving...",
        "sending": "Sending....",
        "copying": "Copying....",
        "downloading": "Downloading....",
        "copySuccessful": "Copy successful",
        "ydhTxtSearch": "Please select the query Type and enter the B/L No. or Container No.",
        "enterNo": "Please enter the inquiry No.",
        "selectType": "Please select query type",
        "selectEntity": "Please select entity",
        "notSupportMulti": "Dear customer, the system does not support the query of multiple Container Nos or B/L Nos currently",
        "charLengthLimitMsg": "The input characters cannot exceed {length} characters * {row} lines. Please use '*' to connect the excess part under the Cargo Desc",
        "charLengthLimitMsg2": "The input characters cannot exceed {length} characters * {row} lines.",
        "cannotMakeBL": "Only the Booking Information whose booking status is ACCEPTED, LOCKED or UNLOCKED can create a B/L. Please select again",
        "noBkPreContainer": "Please add Pre Container Information!",
        "noCargoTypeCode": "【Pre Container Information】Line {index}: Cargo Type Code cannot be empty!",
        "noCargoTypeCode2": "【Container Information】Line {index}: Cargo Type cannot be empty!",
        "illegalCargoTypeCode": "【Container Information】Line {index}: There is no Cargo Type Code {cargoType} in the Pre Container Information!",
        "containerManager": "【Container Information】Line {index}: CNTR Manager cannot be empty!",
        "containerWeight": "【Container Information】Line {index}: Tare Weight cannot be empty!",
        "containerNo": "【Container Information】Line {index}:Container No cannot be empty!",
        "cargoDesc": "【Container Information】Line {index}:DESC. OF GOODS cannot be empty of {serviceLineCode} route!",
        "hsCode": "【Container Information】Line {index}:HS CODE cannot be empty of {serviceLineCode} route!",
        "classType": "【Container Information】Line {index}:the hazardous container IMDG CLASS cannot be Empty of {serviceLineCode} route!",
        "unSerialNo": "【Container Information】Line {index}:the hazardous container UN NO. cannot be Empty of {serviceLineCode} route!",
        "reeferTemp": "【Container Information】Line {index}:the reefer container Temperature cannot be Empty of {serviceLineCode} route!",
        "containerType": "【Container Information】Line {index}: Size/Type cannot be empty!",
        "illegalContainerType": "【Container Information】Line {index}: There is no Size/Type {containerType} in the Pre Container Information!",
        "illegalContainerManager": "【Container Information】Line {index}: The container owner can only be SOC or ZGL",
        "containerManagerMismatchSOC": "Container No: {containerNos} are not Zhonggu-owned containers in the Zhonggu system. Container Manager has been changed to {containerManager}. If you confirm to use Zhonggu-owned containers, please contact the relevant Zhonggu regional staff for timely processing.",
        "containerManagerMismatchZGL": "Container No: {containerNos} are Zhonggu-owned containers in the Zhonggu system. Container Manager has been changed to {containerManager}. Please verify if the container numbers are correct, or if the B/L SOC flag should be cancelled",
        "sealNo1": "【Container Information】Line {index}: Seal No1 cannot be empty!",
        "containerNoDuplicated": "Line {index}: Container No {containerNo} already exists, please check!",
        "containerNoNoMatch": "Line {index}: Container No {containerNo} not match with the international rules of Container No",
        "hsCodeOverLength": "【Container Information】Line {index}: HS CODE cannot exceed {maxLength} characters!",
        "validateQuantity": "The Quantity ({quantity1}) in the Cargo Information does not match the Quantity ({quantity2}) in the Container Information!",
        "validateWeight": "The Gross Weight ({weight1}) in the Cargo Information does not match the Gross Weight ({weight2}) in the Container Information!",
        "validateSize": "The Size ({size1}) in the Cargo Information does not match the Size ({size2}) in the Container Information!",
        "addDgInfoMsg": "There is Pre Container Information with cargo type of [HAZARDOUS], please add DG Information",
        "addDgPreContainerInfoMsg": "Please add the Pre Container Information first with the corresponding cargo type of [HAZARDOUS]",
        "addRfInfoMsg": "There is Pre Container Information with cargo type of [REEFER], please add RF Information",
        "addRfPreContainerInfoMsg": "Please add the Pre Container Information first with the corresponding cargo type of [REEFER]",
        "clearDgInfo": "Please clear the DG Information first!",
        "clearRfInfo": "Please clear the RF Information first!",
        "blSendConfirm": "If the change is made, the fee of 200CNY will be paid for one ticket at a time. Please confirm whether the change is accepted by the Shipping Company. If the B/L has been issued, please replace B/L in time",
        "canNotDownload": "The Shipping Order at the loading port {pol} does not support downloading temporarily",
        "packingListCanNotDownload": "The Packing List(NANSHA) at the loading port {por} does not support downloading",
        "noSaveAndClose": "Are you sure to cancel? Cancel will discard the modification this time.",
        "parseError": "【Data Parsing Failed】",
        "noData2Parse": "There is no data to parse.",
        "bookingNotConfirm": "The selected Manifest is not in booking confirmation status. SO and Packing List(NANSHA) cannot be downloaded!",
        "specialLocked": "Currently, special setting information such as Dangerous / Reefers cannot be entered!",
        "containerWeightNotZero": "【Container Information】Line {index}: Tare Weight cannot be zero!",
        "pleaseEnterqueryConditions": "Please enter the Vessel and Voyage conditions!",
        "pleaseSelecte2Copy": "Please select the Main Bill Info to be copied!",
        "noSelectedHBL": "No Sub B/L selected, cannot copy!",
        "pleaseSelectHBL2Delete": "Please select the Sub B/L record to delete!",
        "noSelectedHBLPreContainer2Delete": "No Sub B/L Pre Container Information is selected to delete!",
        "hblDeleteConfirm": "Are you sure to delete doc Sub B/L【{hbl}】?",
        "hblPreContainerDeleteConfirm": "Are you sure to delete the 【{containerType}】 Pre Container Information？",
        "saveSucceed": "Saved successfully!",
        "cannotLT2HBLS": "There must be at least two pieces of Sub B/L information while splitting!",
        "existsDuplicatedBlNo": "The same B/L No. exists in the Sub B/L Information table, please check!",
        "existsDuplicatedBkNo": "The same Booking No. exists in the Sub B/L Information table, please check!",
        "hblNoBkPreContainer": "The Sub B/L 【{hbl}】has no Pre Container Information and cannot save！",
        "quantityInconsistent": "The Cargo Quantity of the Sub B/L [{quantityTotal}] is inconsistent with the Quantity of the Top B/L [{quantity}], please check!",
        "weightInconsistent": "The Cargo Gross Weight of the Sub B/L [{grossWeightTotal}] is inconsistent with the Gross Weight of the Top B/L [{cargoGrossWeight}], please check!",
        "sizeInconsistent": "The Cargo Size of the Sub B/L [{cargoSizeTotal}] is inconsistent with the Size of the Top B/L [{cargoSize}], please check!",
        "noMatchCannotSplite": "The Vessel Name, Voyage, POD and Shipper of the Sub B/L and Top B/L must be the same before splitting!",
        "hblInfoNoBlNo": "【Sub B/L Information】Line {index}: B/L No. cannot be empty!",
        "hblInfoNoBkNo": "【Sub B/L Information】Line {index}: Booking No. cannot be empty!",
        "hblInfoNoCargoShippingMark": "【Sub B/L Information】Line {index}: Cargo Shipping Mark cannot be empty!",
        "hblInfoNoCargoQuantity": "【Sub B/L Information】Line {index}: B/L Cargo Quantity cannot be empty, and not be zero too！",
        "hblInfoNoCargoGrossWeight": "【Sub B/L Information】Line {index}: B/L Cargo Gross Weight cannot be empty, and not be zero too！",
        "hblInfoNoCargoSize": "【Sub B/L Information】Line {index}: B/L Cargo Size cannot be empty, and not be zero too！",
        "cancelSpliteNote": "Do you want to delete the Sub B/Ls {hbls} while canceling splitting？",
        "chooseHBL2SetMBL": "Please select the Sub B/L to be set as the Top B/L in the Sub B/L Information table below!",
        "cancelCombineNote": "Please select the Top B/L to cancel first!",
        "cancelCombineConfirm": "Are you sure to cancel the combin?",
        "removeCheckedHBLConfirm": "Are you sure to remove the checked Sub B/L records?",
        "noSelectedHBL2Delete": "Please check the Sub B/L records to be removed first!",
        "validateFileTypeFailed": "（{fileName}） upload failed! Only *.pdf, *.png, *.jpg, *.jpeg files can be uploaded",
        "guaranteeUploadSizeLimit": "The size of file [{fileName}] ({fileSize}) exceeds the maximum limit. The size of a single file cannot exceed 5M!",
        "guaranteeUpload413Error": "File [{fileName}] upload failed! File is too large for the server to process. Please ensure the file size does not exceed 5M, or contact the administrator to increase the server upload size limit.",
        "guaranteeUploadValidationFailed": "The following files failed validation. Please correct and re-upload:",
        "guaranteeUploadValidationTitle": "File Validation Failed",
        "guaranteeDeleteConfirm": "This will permanently delete the selected guarantee. Do you want to continue?",
        "guaranteeDeleteSucceed": "Delete Succeed!",
        "noGuaranteeFilesUploaded": "Guarantee not uploaded",
        "noDataSelected": "You have not selected any record currently",
        "blBatchDownloadFailed": "【{blNo}】download failed! You can try to download a single ticket",
        "cargoInformationSizeNotNull":"The cargo information size cannot be empty!",
        "enterAtLeastOne": "Please enter at least one condition to query!",
        "invoiceDownloadErrorTitle":"The invoice has not been uploaded as an attachment yet",
        "invoiceNotDelete":"The current invoice has been submitted and cannot be deleted! If you are sure you want to delete it, please apply for a return of the current invoice first",
        "deleteCurrentInvoice":"Are you sure to delete the current invoice? (If there is actual receipt registration data, invoice deletion will automatically delete the corresponding actual receipt registration data)",
        "ConfirmSubmission":"Are you sure to submit the current invoice application? The invoice information cannot be modified after submitting the application",
        "SetTomorrow":"The current time has exceeded 16:00 Beijing time. Would you like to set the invoicing date to tomorrow?",
        "invoiceDeleteConfirm":"The current invoice has been submitted and cannot be deleted! If you are sure you want to delete it, please apply for a return of the current invoice first",
        "invoiceDeleteConfirmTwo":"Are you sure to delete the current invoice? (If there is actual receipt registration data, invoice deletion will automatically delete the corresponding actual receipt registration data)",
        "invoiceSubmitConfirm":"Are you sure to submit the current invoice application? The invoice information cannot be modified after submitting the application",
        "invoiceNowHourConfirm":"The current time has exceeded 16:00 Beijing time. Would you like to set the invoicing date to tomorrow?",
        "invoiceReturn":"The current invoice has been submitted. Do you want to apply for a return?",
        "returnApply":"The return request has been sent!",
        "copyBill":"The SOA No. has been copied and can be directly pasted on the Reconciliation Management page for querying",
        "copyBillFailed": "Copy failed! Please try copying manually",
        "invoiceSubmitted": "The current invoice has been submitted and cannot be resubmitted!",
        "invoiceNotAllowed2Commit": "There are already submitted invoices and cannot be resubmitted. Please reselect!",
        "applicationUnitLengthWarn": "The character length filled in by the Applicant Unit exceeds the limit! The current input is {charLength} characters (up to 20 characters allowed, only English characters are supported)",
        "grossWeightLessThanNetWeight": "[Cargo Information] Gross Weight cannot be less than Net Weight!",
    },
    /*用户中心*/
    "userCenter":{
        /*个人信息*/
        "personalInfo":{
            "personalInfo":"Personal Information",
            "changePassword":"Change password",
            "modifyInformation":"Modify information",
            "currentPassWord":"Current Password",
            "newPassword":"New Password",
            "confirmPassword":"Confirm Password",
            "companyCode":"Customer code",
            "companyNameCn":"Customer name(CN)",
            "companyName":"Customer name(EN)",
            "newPasswordTip":"Please enter a new password",
            "confirmPasswordTip":"Please enter the password again",
            "confirmPasswordWarn":"The two passwords are inconsistent!",
            "currentPassWordTip":"Please enter the current password!",
            "resetPassword":"Reset Password",
        },
    },
    "vxe": {
        "loading": {
            "text": "Loading..."
        },
        "modal": {
            "close": "Close",
        },
        "pager": {
            "prevPage": "Pre Page",
            "nextPage": "Next Page",
            "goto": "Go to Page",
            "nextJump": "Skip Page Down",
            "prevJump": "Skip Page Up",
            "pageClassifier": "",
            "pagesize": "{0}/Page",
            "total": "{0} Records in Total",
        },
        "table": {
            "emptyText": "No data",
            "allTitle": "All",
            "sortAsc": "Descending",
            "sortDesc": "Ascending",
            "expFilename": "{0}",
            "expSuccess": "Data export successful"
        },
        "export": {
            "expTitle": "Export Data",
            "expNamePlaceholder": "Please enter a file name",
            "expName": "Export File Name",
            "expType": "Save Type",
            "expMode": "Select data",
            "expColumn": "Select Column",
            "expOpts": "Export Options Settings",
            "expCurrentColumn": "All Columns",
            "expOptHeader": "Table header",
            "expHeaderTitle": "Need a header?",
            "expOptFooter": "Table Footer",
            "expOptOriginal": "Source Data",
            "expOptColgroup": "Group Header",
            "expOptMerge": "Merge",
            "expOptUseStyle": "Style",
            "expOptAllExpand": "Expand Hierarchy",
            "expCancel": "Cancel",
            "expConfirm": "Confirm",
            "expFooterTitle": "Need a footer?",
            "expOriginalTitle": "Export as source data?",
            "expColgroupTitle": "If present, supports header with grouping structure",
            "expMergeTitle": "If present, supports cells with merged structures",
            "expUseStyleTitle": "If present, supports styled cells",
            "expAllExpandTitle": "If present, it supports expanding all data with a hierarchical structure",
            "printTitle": "Print Table Data",
            "expSheetName": "Title",
            "expSheetNamePlaceholder": "Please enter a title",
            "expPrint": "Print",
            "types": {
                "csv": "(*.csv)",
            },
            "modes": {
                "current": "Current data (data from the current page)",
                "selected": "Selected data (data selected on the current page)",
            },
        },
        "toolbar": {
            "print": "Print",
            "custom": "Column Settings",
            "customAll": "All",
            "customConfirm": "Confirm",
            "customRestore": "Reset",
            "zoomIn": "Full Screen",
            "zoomOut": "Exit Full Screen",
        },
        "error": {
            "reqProp": "reqProp"
        }
    },
    "demurrageRate": {
        "bannerTitle": "Demurrage Rate File Download Center",
        "bannerDescription": "This page provides PDF download services for demurrage rate files from various regions at home and abroad. All files are official releases. For inquiries, please contact Zhonggu customer service",
        "domesticRegion": "Rates in China",
        "foreignRegion": "Rates outside China",
        "fileSize": "File Size: ",
        "publishDate": "Publish Date: ",
        "downloadComplete": "Download Complete",
        "searchPlaceholder": "Enter the name of the country or region to search",
        "searchButton": "Search"
    }
};

export default en;